"use client";

import { ExpandingMenuProvider } from "./expanding-menu.context";
import type { ExpandingMenuProps } from "./types/expanding-menu.types";

import { expandingMenuStyles } from "./styles/expanding-menu.styles";

import { ExpandingMenuTrigger } from "./expanding-menu-trigger";
import { ExpandingMenuContent } from "./expanding-menu-content";
import { ExpandingMenuItem } from "./expanding-menu-item";

type ExpandingMenuComponents = {
  Trigger: typeof ExpandingMenuTrigger;
  Content: typeof ExpandingMenuContent;
  Item: typeof ExpandingMenuItem;
};

export const ExpandingMenu: React.FC<ExpandingMenuProps> & ExpandingMenuComponents = (props) => {
  const { children, className, ...rest } = props;

  const styles = expandingMenuStyles({ className });

  return (
    <ExpandingMenuProvider {...rest}>
      <div className={styles}>{children}</div>
    </ExpandingMenuProvider>
  );
};

ExpandingMenu.Trigger = ExpandingMenuTrigger;
ExpandingMenu.Content = ExpandingMenuContent;
ExpandingMenu.Item = ExpandingMenuItem;

ExpandingMenu.displayName = "ExpandingMenu";
